import { navActions } from "../../Redux/nav/nav.slice"
import { logoutThunk } from "../LoginPage/redux/auth.thunks"
import { getUserInfo } from "./redux/user.thunks"

/* eslint-disable import/no-named-as-default-member */
export default {
  logout: logoutThunk,
  changeTheme: navActions.navSetProp,
  getUserInfo,
  setDisabledTransition: navActions.navSetProp
}
